import React from "react";
import Card from "apollo-react/components/Card";
import Typography from "apollo-react/components/Typography";
import Button from "apollo-react/components/Button";
import OpenNew from "apollo-react-icons/OpenNew";
import { appConfig } from "../config/appConfig";

const SupportSection: React.FC = () => {
  const handleContactClick = () => {
    window.open(appConfig.APP_CONTACT_US, "_blank");
  };

  const handleFeedbackClick = () => {
    window.open(appConfig.APP_FEEDBACK, "_blank");
  };

  return (
    <div
      style={{
        backgroundColor: "#F6F7FB",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          padding: "clamp(16px, 4vw, 24px)",
          maxWidth: "1200px",
          margin: "0 auto",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Typography
          className="fw700-32"
          style={{
            marginBottom: "clamp(16px, 3vw, 24px)",
            textAlign: "left",
            color: "#1A1A1A",
          }}
        >
          Support
        </Typography>
        {/* Grid container for both cards - matches application cards styling */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "16px",
            width: "100%",
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          {/* Global Contact Center Card */}
          <Card
            style={{
              padding: "clamp(20px, 4vw, 32px)",
              backgroundColor: "#FFFFFF",
              border: "1px solid #E0E0E0",
              borderRadius: "12px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              boxSizing: "border-box",
              display: "flex",
              flexDirection: "column",
              minHeight: "200px",
            }}
          >
            <div
              style={{
                flex: "1 1 auto",
                marginBottom: "clamp(16px, 3vw, 24px)",
              }}
            >
              <Typography
                className="fw700-24"
                style={{
                  marginBottom: "clamp(8px, 2vw, 16px)",
                  color: "#1A1A1A",
                  lineHeight: "1.3",
                }}
              >
                Global Contact Center
              </Typography>

              <Typography
                className="fw400-16"
                style={{
                  color: "#666666",
                  lineHeight: "1.5",
                  margin: "0",
                  fontSize: "clamp(14px, 2.5vw, 16px)",
                }}
              >
                The global contact center provides 24x7 support for
                troubleshooting, accounts, supplies, and more. For urgent
                requests, please call us on the toll-free numbers provided for
                your country in your manual or at the link below.
              </Typography>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                flex: "0 0 auto",
              }}
            >
              <Button
                variant="secondary"
                size="small"
                endIcon={<OpenNew />}
                onClick={handleContactClick}
              >
                Contact Us
              </Button>
            </div>
          </Card>
          {/* Send Feedback Card */}
          <Card
            style={{
              padding: "clamp(20px, 4vw, 32px)",
              backgroundColor: "#FFFFFF",
              border: "1px solid #E0E0E0",
              borderRadius: "12px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              boxSizing: "border-box",
              display: "flex",
              flexDirection: "column",
              minHeight: "200px",
            }}
          >
            <div
              style={{
                flex: "1 1 auto",
                marginBottom: "clamp(16px, 3vw, 24px)",
              }}
            >
              <Typography
                className="fw700-24"
                style={{
                  marginBottom: "clamp(8px, 2vw, 16px)",
                  color: "#1A1A1A",
                  lineHeight: "1.3",
                }}
              >
                Send Your Feedback
              </Typography>

              <Typography
                className="fw400-16"
                style={{
                  color: "#666666",
                  lineHeight: "1.5",
                  margin: "0",
                  fontSize: "clamp(14px, 2.5vw, 16px)",
                }}
              >
                We are always trying to improve your experience with our
                products. If you have any feedback or suggestions for
                improvements, we want to hear from you!
              </Typography>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                flex: "0 0 auto",
              }}
            >
              <Button
                variant="secondary"
                size="small"
                endIcon={<OpenNew />}
                onClick={handleFeedbackClick}
              >
                Send Feedback
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default SupportSection;